module.exports = function () {
    return window;
};



//////////////////
// WEBPACK FOOTER
// ./~/jpex-web/src/$window.js
// module id = 1064
// module chunks = 0